import {connect} from 'react-redux';
import MarketingStepView from '../../../components/views/mx/seminuevos/MarketingStepView';
import * as WizardMXActions from '../../../actions/WizardMXActions';

const mapStateToProps = state => ({
    channelReferents: state.catalogs.channelReferents.map(item =>
        ({id: item.id, value: item.value, label: item.value})
    )
});

const mapDispatchToProps = dispatch => ({
    onSelectMarketingChannel: (channelSelected) => {
        dispatch(WizardMXActions.SAVE_MARKETING_MX_ACTION.action(channelSelected));
    }
});

const mergeProps = (stateProps, dispatchProps) => ({
    ...stateProps,
    ...dispatchProps
});

const MarketingStepContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(MarketingStepView);

export default MarketingStepContainer;
